import type { ChangeEvent } from 'react'
import React from 'react'
import { TextInput, InlineDisplayContent } from '@ztechapps/webui.input'
import type { ReactNode } from '@mdx-js/react/lib'

export const AddressDisplayContent = ({
  content,
  value,
  label,
  onChange,
  help,
  meta,
  disabled,
}: {
  content?: ReactNode
  value?: any
  label?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  help?: string
  meta?: any
  disabled?: boolean
}) => {
  content = content || <TextInput value={value} onChange={onChange} disabled={disabled} />

  return (
    <InlineDisplayContent label={label} help={help} meta={meta}>
      {/* Fragment needed to handle various content types */}
      {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
      <>{content}</>
    </InlineDisplayContent>
  )
}
